





















import { Component, Vue, Prop } from "vue-property-decorator";
import { ProdutosService } from "@/services/produtos.service";
import Loading from "@/shared/components/loading.vue";

@Component({
  components: {
    Loading,
  },
})
export default class SelectTipoProduto extends Vue {
  @Prop({ default: null }) value!: string;
  @Prop() label!: string;
  @Prop() rules!: any;
  @Prop() disabled!: boolean;

  loading = false;
  tipos: { key: number; value: string }[] = [];
  created() {
    this.fetchTipos();
  }
  async fetchTipos() {
    this.loading = true;
    this.tipos = await ProdutosService.listarTipos(
      this.$route.params.idCatalogo
    );
    this.loading = false;
  }

  emitirInput(val: number) {
    this.$emit("input", val);
  }
}
